import React, { useState } from 'react'
import { Envelope, PencilLine, Trash } from '@phosphor-icons/react'
import { EmailTemplateResp } from 'types/globalTypes'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { capitalizeFirstLetter, convertToLocal } from 'helper/utility'
import { EventEmailTemplateResp } from 'types/event/eventStep5'
import { Checkbox } from 'antd'
import Chip from 'components/global/Chip'
import { creationEventStore } from 'state/event/eventCreationStore'
import { EventResp } from 'types/event/events'
import Preview from 'pages/Events/Views/Common/ModalCotent/EmailTemplate/Preview/Preview'

interface TemplateInfoProps {
  template: EventEmailTemplateResp
  loaderId: string
  isEventTemplate: boolean
  handleAddToEvent: (id: string, operation: 'add' | 'remove') => void
  handleEditTemplate: (template: EmailTemplateResp) => void
}

const TemplateInfoLeague: React.FC<TemplateInfoProps> = ({
  template,
  loaderId,
  isEventTemplate,
  handleAddToEvent,
  handleEditTemplate,
}) => {
  const { eventData }: { eventData: EventResp } = creationEventStore(store => ({
    eventData: store.eventData,
  }))
  const [openPreviewModal, setOpenPreviewModal] = useState<boolean>(false)

  const getAgeTagText = (minAge?: number, maxAge?: number) => {
    if (minAge === 0 && maxAge === 0) return 'All Ages'
    if (minAge && !maxAge) return `Ages ${minAge}+`
    if (!minAge && maxAge) return `Ages up to ${maxAge}`
    if (minAge && maxAge) return `Ages ${minAge}-${maxAge}`
    return 'All Ages'
  }

  const hanldeChange = (value: boolean) => {
    handleAddToEvent(template._id, value ? 'add' : 'remove')
  }

  return (
    <>
      <div className="py-15px border-btm flex align-center justify-between gap-40px">
        <div className="w-70p">
          {loaderId === template._id ? (
            <ButtonSpinner size={20} color="#2ba7ca" />
          ) : (
            <Checkbox
              checked={template.status === 'active'}
              onChange={e => hanldeChange(e.target.checked)}
            >
              <div>
                <h3 className="text-16 w-500">
                  {capitalizeFirstLetter(template.templateName)}
                </h3>
                {template.customTimeToSend ? (
                  <p>{`Send at ${convertToLocal(template.description)}`}</p>
                ) : (
                  <p>{`Send ${template.description}`}</p>
                )}
                <div className="flex gap-10px align-center flex-wrap">
                  {template.recipientsToSend.gender ? (
                    <Chip
                      text={capitalizeFirstLetter(
                        template.recipientsToSend.gender,
                      )}
                    />
                  ) : null}
                  <Chip
                    text={getAgeTagText(
                      template.recipientsToSend.minAge,
                      template.recipientsToSend.maxAge,
                    )}
                  />
                </div>
              </div>
            </Checkbox>
          )}
        </div>
        <div className="flex gap-20px align-center">
          <button
            className="borderd-btn"
            onClick={() => setOpenPreviewModal(true)}
          >
            Preview
          </button>
          <button
            className="borderd-btn"
            onClick={() => handleEditTemplate(template)}
          >
            Edit
          </button>
        </div>

        <Preview
          openModal={openPreviewModal}
          closeModal={setOpenPreviewModal}
          template={template}
        />
      </div>
    </>
  )
}

export default TemplateInfoLeague
